function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "lKHswt"
}, /*#__PURE__*/React.createElement("path", {
  d: "M87,79.68a17.56,17.56,0,0,1-.7,2.16,8.45,8.45,0,0,1-13.83,2.63c-5-4.89-9.91-9.88-14.85-14.83a5.14,5.14,0,0,1-1.32-5.46.93.93,0,0,0-.1-.74c-1.64-1.68-3.3-3.33-4.87-4.9-1.92,1.06-3.69,2.19-5.58,3.06A31.56,31.56,0,0,1,27.9,64.24a31.5,31.5,0,0,1-16.55-7.4A31.71,31.71,0,0,1,.46,37.54,32.18,32.18,0,0,1,11.68,7.42a30.34,30.34,0,0,1,12-6.23c2-.51,4.14-.8,6.22-1.19h4.75c1.26.18,2.52.31,3.76.56A32.17,32.17,0,0,1,54,8.44,31.72,31.72,0,0,1,64.5,30.12a30.87,30.87,0,0,1-3.66,17.17c-.72,1.34-1.54,2.63-2.34,4,1.6,1.6,3.22,3.22,4.87,4.82a.89.89,0,0,0,.71.23,5.41,5.41,0,0,1,6,1.66c4.3,4.36,8.61,8.69,13,13,1.86,1.81,3.45,3.72,4,6.34ZM61.14,32.22A28.67,28.67,0,0,0,32.21,3.44,28.6,28.6,0,0,0,3.46,32.29a28.84,28.84,0,1,0,57.68-.07Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.33,6.8A25.13,25.13,0,0,0,8.24,23.91C5.1,33.32,6.82,42,13.48,49.41a24.37,24.37,0,0,0,21,8.2A25.47,25.47,0,0,0,55.05,20.78c-.71-1.45-1.58-1.91-2.61-1.41s-1.2,1.46-.48,2.93a22,22,0,0,1-3.77,25.23A20.82,20.82,0,0,1,35.64,54a21.68,21.68,0,0,1-20-7.34A22.09,22.09,0,0,1,29.05,10.42a21.11,21.11,0,0,1,12.56,1.84c.49.23,1,.49,1.46.67a1.64,1.64,0,0,0,2.09-.76A1.59,1.59,0,0,0,44.55,10a26.64,26.64,0,0,0-3.76-1.74A23.76,23.76,0,0,0,32.33,6.8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.42,15.43a1.69,1.69,0,1,0,3.38,0,1.69,1.69,0,0,0-1.72-1.71A1.66,1.66,0,0,0,47.42,15.43Z"
}))));
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87 87.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.376813a2aa2d8ab436763fa5640336f4.svg";
export { ForwardRef as ReactComponent };